/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Difference_Stat_PositionInputs */

const et_difference_stat_position = /** @type {(inputs: Difference_Stat_PositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keskmine koht`)
};

const en_difference_stat_position = /** @type {(inputs: Difference_Stat_PositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Average position`)
};

/**
* | output |
* | --- |
* | "Average position" |
*
* @param {Difference_Stat_PositionInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const difference_stat_position = /** @type {((inputs?: Difference_Stat_PositionInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Difference_Stat_PositionInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_difference_stat_position(inputs)
	return en_difference_stat_position(inputs)
});